var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from 'react';
import { Link, Text } from 'pcln-design-system';
/** @public */
function ContentfulCallToAction(_a) {
    var ariaLabel = _a.ariaLabel, color = _a.color, fontSize = _a.fontSize, fontWeight = _a.fontWeight, label = _a.label, longUrl = _a.longUrl, openInNewTab = _a.openInNewTab, textStyle = _a.textStyle, url = _a.url, props = __rest(_a, ["ariaLabel", "color", "fontSize", "fontWeight", "label", "longUrl", "openInNewTab", "textStyle", "url"]);
    var href = longUrl || url;
    var target = openInNewTab ? '_blank' : '_self';
    return (
    // @ts-ignore
    React.createElement(Link, __assign({ "aria-label": ariaLabel, color: color, href: href, target: target }, props),
        React.createElement(Text, { fontSize: fontSize, fontWeight: fontWeight, textStyle: textStyle }, label)));
}
export default memo(ContentfulCallToAction);
//# sourceMappingURL=ContentfulCallToAction.js.map